import {
  EditorElement,
  EditorReactComponent,
  ElementItem,
} from '@wix/component-protocol/schema';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { objectMap } from '../../../../utils';
import { ManifestProcessor } from '../../types';
import { AbstractVirtualManifestBuilder } from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { filterStylesByActionName } from '../stylesFilter';
import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

const processElements = (
  elements: Record<string, ElementItem>,
  actionName: StylesDerivedNativeActionNames,
  builder: AbstractVirtualManifestBuilder,
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerServiceAPI,
) => {
  objectMap(elements, (element, elementId) => {
    if (element?.elementType === 'inlineElement' && element.inlineElement) {
      const elementEditorPointer = editorPointerAPI.buildEditorPointer(
        editorPointerAPI.getDocumentPointer(editorPointer),
        [...(editorPointer.innerElementPath ?? []), elementId],
      );
      processElement(
        element.inlineElement,
        actionName,
        builder,
        elementEditorPointer,
        editorPointerAPI,
      );
    }
  });
};

const processElement = (
  elementManifestStructure: EditorElement,
  actionName: StylesDerivedNativeActionNames,
  builder: AbstractVirtualManifestBuilder,
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerServiceAPI,
) => {
  // ignore everything that is not style or elements
  const relevantStructure = {
    cssCustomProperties: elementManifestStructure.cssCustomProperties,
    cssProperties: elementManifestStructure.cssProperties,
    elements: elementManifestStructure.elements,
  };

  const filteredStyles = filterStylesByActionName(actionName, {
    cssCustomProperties: relevantStructure.cssCustomProperties || {},
    cssProperties: relevantStructure.cssProperties || {},
  });

  builder.withManifest(editorPointer, {
    editorElement: {
      ...relevantStructure,
      ...filteredStyles,
    },
  });

  if (relevantStructure?.elements) {
    processElements(
      relevantStructure.elements,
      actionName,
      builder,
      editorPointer,
      editorPointerAPI,
    );
  }
};

const defaultStrategy: ManifestProcessor = (
  manifest: EditorReactComponent,
  actionName: StylesDerivedNativeActionNames,
  builder: AbstractVirtualManifestBuilder,
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerServiceAPI,
) => {
  if (manifest?.editorElement) {
    processElement(
      manifest?.editorElement,
      actionName,
      builder,
      editorPointer,
      editorPointerAPI,
    );
  }
};

export default defaultStrategy;
